import { inject } from '@angular/core';
import { GuardResult, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, Observable, take } from 'rxjs';
import { selectUserContextState } from '../user-context/store/user-context.selectors';
import { UserContext } from '../user-context/user-context.model';

/**
 * The shared shape of the user-context guards: wait until the user context has loaded
 * (or failed), then let `decide` rule on it. With no context the guard fails closed to
 * /unauthorized (SECURITY-08). Call it in the guard body (injection context).
 */
export function withUserContext(
  decide: (context: UserContext) => GuardResult,
): Observable<GuardResult> {
  const router = inject(Router);
  return inject(Store)
    .select(selectUserContextState)
    .pipe(
      filter((state) => state.status === 'loaded' || state.status === 'error'),
      take(1),
      map((state) =>
        state.context ? decide(state.context) : router.createUrlTree(['/unauthorized']),
      ),
    );
}
